import * as Sentry from "@sentry/react";
import { excludeGraphQLFetch } from "apollo-link-sentry";

const urlParams = new URLSearchParams(window.location.search);
const enableSentry = urlParams.get("enablePerformance") === "true";

if (
  process.env.RUNTIME_ENV !== "development" &&
  process.env.NODE_ENV !== "test" &&
  enableSentry
) {
  Sentry.init({
    beforeBreadcrumb: excludeGraphQLFetch,
    debug: process.env.RUNTIME_ENV !== "production",
    dsn: "https://f9e01ff26fff393a6b3bf80dc4bfe3a5@relay-prod.services.appointedd.com/4507351660560464",
    environment: process.env.RUNTIME_ENV === "production" ? "prod" : "test",
    initialScope: {
      tags: {
        "test.env": process.env.RUNTIME_ENV,
      },
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: false,
        /**
         * Prevent PII from being sent to Sentry by masking all inputs in
         * production. We can have this enabled in our testing/staging
         * environments to aid with debugging as there is no risk of PII on
         * those environments.
         */
        maskAllInputs: process.env.RUNTIME_ENV === "production",
        maskAllText: false,
      }),
    ],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate:
      process.env.RUNTIME_ENV === "production" ? 0.05 : 0.0,
    tracesSampleRate: 1.0,
  });
}
